export const useNest = () => {
  const config = useRuntimeConfig();
  return {
    StaticFileUrl: (FileObject: { path: string }): string => {
      return (
        config.public.app_nest_url +
        "/" +
        FileObject.path.replace("public", "")
      );
    },
  };
};
